import React from 'react';
import Header from '../../../header/header';
import Footer from '../../../footer/footer';
import ImageSlider from './carrousselsenior';



const Senior = (props) => {

  return (
    <div>  
            <Header />

    <div id="activites">

      <div className="container">
<br></br>
<br></br>
        <div className="section-title">
          <h2>Les ateliers pour les séniors</h2>
          <br></br>
              <br></br>
                     <div className="activites-list" >
<br></br>
          <div className="col-xs-12 col-md-6">
<ImageSlider /><br></br><br></br></div>
              <div className="col-xs-12 col-md-6">
  <p>
        Offrez à vos résidents des moments conviviaux et créatifs, conçus pour stimuler les sens et favoriser le bien-être collectif.
      </p>

      <p>
        Mes ateliers floraux durent environ 1 heure et sont spécialement adaptés aux seniors. Ils permettent de se reconnecter à la nature tout en développant la mémoire, le toucher, l’odorat et la créativité.
      </p>
<br></br>
      <h4>Les thématiques tout au long de l’année</h4>
<br></br>
      <ul className='libouquets'>
        <li><strong>Octobre</strong> : créations autour des citrouilles</li>
        <li><strong>Décembre</strong> : ateliers festifs pour les fêtes de fin d’année</li>
        <li><strong>Janvier</strong> : découverte des plantes hivernales</li>
        <li><strong>Avril</strong> : bouquets printaniers</li>
        <li><strong>Mai</strong> : célébration de la fête des mères</li>
      </ul>
<br></br>
   


      <p>
        Il s’agit d’une expérience ludique, sensorielle et réconfortante, avec le matériel et les fleurs inclus.
      </p>
      <br></br>
<br></br>
<br></br>
      </div>
<br></br>
<br></br>
<br></br>
   
        </div>
        
      </div>
      </div>
  </div>
      < Footer />

    </div>

  );
};
export default Senior;